import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import 'vis-network/styles/vis-network.min.css'; // test
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import Toolbar from './components/Toolbar';
import NetworkPanel from './components/NetworkPanel';
import Sidebar from './components/Sidebar';
import VersionDisplay from './components/VersionDisplay';
import './App.css';

function App() {
  const network = useRef(null);
  const meta = useSelector((state) => state.networkUndo.present.meta);

  useEffect(() => {
    document.title = 'title' in meta ? `${meta.title}` : 'Untitled';
  }, [meta]);

  return (
    <div className="App">
      <Toolbar />
      <Sidebar />
      <NetworkPanel network={network} />
      <VersionDisplay />
    </div>
  );
}

export default App;
